import "./VehiclesDetailsHeader.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { openModal } from "../../../../../slices/modalSlice";

import Upload from "@mui/icons-material/Upload";

import { Button } from "../../../../../common-components/Buttons/Buttons";
import { LargeTitle } from "../../../../../common-components/Titles/Titles";

import VehiclesUploadModal from "../VehiclesUploadModal/VehiclesUploadModal";

const VehiclesDetailsHeader = ({id}) => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openModal({closeable: true, content: <VehiclesUploadModal id={id}/>}));
    }

    return (
        <div className={"vehicles-details-header"}>
            <div className={"vehicles-details-header_container"}>
                <div className={"vehicles-details-header_title"}>
                    <LargeTitle property={"Детальная информация"}/>
                </div>
                <div className={"vehicles-details-header_button"}>
                    <Button Icon={Upload} title={"Загрузить фото"} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesDetailsHeader;